import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { toast } from "react-toastify";
import Select from "react-select";
import { FaPlus } from "react-icons/fa";
import CreateCustomerModal from "../../Modals/CreateCustomerModel";
import AddTagModal from "../../Modals/AddTagModel";
import { useCommonContext } from "../../../utils/context";
import AgentModal from "../../Modals/AgentModel";
import { useTypeConfig } from "../../../utils/useTypeConfig";
import { useLocation, useNavigate } from "react-router-dom";

function GenerateTicketsModal({
  show,
  handleClose,
  ticket,
  fetchTickets,
  action,
  setTicketAction,
}) {
  const { labels, hiddenFields } = useTypeConfig();
  const [subCustomers, setSubCustomers] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [brandNames, setBrandNames] = useState({});
  const [catNames, setCatNames] = useState({});
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
  const [showAddTagModal, setShowAddTagModal] = useState(false);
  const [showTechnicianModal, setShowTechnicianModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedButton, setSelectedButton] = useState("AMC");
  const [showRateInput, setShowRateInput] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const [cusAmcs, setCusAmcs] = useState({});

  const [fsrData, setFsrData] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [selectedFsr, setSelectedFsr] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedAssignTo, setSelectedAssignTo] = useState(null);
  const [selectedSubCustomer, setSelectedSubCustomer] = useState(null);
  const [selectedCat, setSelectedCat] = useState(null);
  const [selectedCusAmc, setSelectedCusAmc] = useState(null);

  const [selectedBrandName, setSelectedBrandName] = useState(null);
  const { technicians, fetchTechnicians } = useCommonContext();
  const { fetchCustomers, customers } = useCommonContext();

  useEffect(() => {
    fetchFsrs();

    fetchService();
  }, []);

  useEffect(() => {
    fetchSubCustomersTec(selectedCustomer?.value);
    fetchCustomersProduct(selectedCustomer?.value);
    fetchFsrCat(selectedFsr?.value);
  }, [showAddTagModal]);

  useEffect(() => {
    if (ticket) {
      if (ticket.customerDetails?.id) {
        fetchSubCustomersTec(ticket.customerDetails.id);
        fetchCustomersProduct(ticket.customerDetails.id);
      }

      if (ticket.fsrDetails?.id) {
        fetchFsrCat(ticket.fsrDetails.id);
      }

      if (ticket.product_name?.id) {
        fetchCusAmc(ticket.product_name.id);
      }
    }
  }, [ticket]);

  useEffect(() => {
    if (ticket) {
      reset({
        taskName: ticket.taskName || "",
        date: ticket.date || "",
        time: ticket.time || "",
        rate: ticket.rate || "",

        purpose: ticket.purpose || "",

        model: ticket.model || "",
        status: ticket.status || "",

        instructions: ticket.instructions || "",
      });

      setSelectedAssignTo({
        value: ticket.assignTo?.id,
        label: ticket.assignTo?.first_name + " " + ticket.assignTo?.last_name,
      });
      setCustomerData(ticket.customerDetails || null);
      setSelectedCustomer({
        value: ticket.customerDetails?.id,
        label:
          ticket.customerDetails?.customer_name +
          (ticket.customerDetails?.customer_tag
            ? ` - ${ticket.customerDetails.customer_tag}`
            : ""),
      });
      if (ticket.isamc === "true") {
        setSelectedButton("AMC");
        setShowRateInput(false);
      } else if (ticket.israte === "true") {
        setSelectedButton("Rate");
        setShowRateInput(true);
      } else {
        setSelectedButton(null);
        setShowRateInput(false);
      }

      setSelectedFsr({
        value: ticket.fsrDetails?.id,
        label: ticket.fsrDetails?.fsrName,
      });

      setSelectedService({
        value: ticket.serviceDetails?.id,
        label: ticket.serviceDetails?.service_name,
      });
      setSelectedButton(ticket.isamc === "true" ? "AMC" : "Rate");
      setShowRateInput(ticket.isamc !== "true");

      setSelectedSubCustomer({
        value: ticket.subCustomerDetails?.id,
        label: ticket.subCustomerDetails?.customer_name,
      });

      setSelectedCat({
        value: ticket.selected_cat?.id,
        label: ticket.selected_cat?.name,
      });

      setSelectedCusAmc({
        value: ticket.selected_amc?.amcid,
        label: ticket.selected_amc?.amcName,
      });

      setSelectedBrandName({
        value: ticket.product_name?.id,
        label: ticket.product_name?.name,
      });
    } else {
      reset({});
      setSelectedButton("AMC");
      setShowRateInput(false);
      setCustomerData(null);
      setSelectedCustomer(null);
      setSelectedFsr(null);
      setSelectedService(null);
      setSelectedAssignTo(null);
      setSelectedSubCustomer(null);
      setSelectedCat(null);
      setSelectedCusAmc(null);
      setSelectedBrandName(null);
    }
  }, [show, ticket, reset]);

  const fetchService = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/services/?page_size=all`,
        {
          headers: {
            ...HEADERS,
          },
        },
      );
      setServiceData(response.data.results);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCustomersTec = async (customerId) => {
    if (!customerId) return;
    try {
      const { data } = await axios.get(
        `${BASE_URL}/users/tms_users/?role=subcustomer&customer_id=${customerId}&page_size=all`,
        { headers: HEADERS },
      );

      if (Array.isArray(data.results)) {
        setSubCustomers((prev) => ({
          ...prev,
          [customerId]: data.results,
        }));
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching subcustomers:", error);
    }
  };

  const fetchCustomersProduct = async (customerId) => {
    if (!customerId) return;
    try {
      const { data } = await axios.get(
        `${BASE_URL}/users/customer_brandnames/${customerId}`,
        { headers: HEADERS },
      );

      if (Array.isArray(data)) {
        setBrandNames((prev) => ({
          ...prev,
          [customerId]: data,
        }));
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  };

  const fetchCusAmc = async (brandId) => {
    if (!brandId) return;
    try {
      const { data } = await axios.get(
        `${BASE_URL}/api/brand_amc_name/${brandId}/`,
        { headers: HEADERS },
      );

      if (Array.isArray(data)) {
        const filteredData = data.filter((amc) => amc.status !== "Expired");

        setCusAmcs((prev) => ({
          ...prev,
          [brandId]: filteredData,
        }));
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching AMC:", error);
    }
  };

  const fetchFsrCat = async (fsrId) => {
    if (!fsrId) return;
    try {
      const { data } = await axios.get(
        `${BASE_URL}/api/fsr_categories_name/${fsrId}`,
        { headers: HEADERS },
      );

      if (Array.isArray(data)) {
        const options = data.map((item) => ({
          value: item.category_id,
          label: item.category_name,
        }));

        setCatNames((prev) => ({
          ...prev,
          [fsrId]: options,
        }));
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    }
  };

  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedCustomer(null);
      return;
    }

    const fullCustomer = customers.find((c) => c.id === selectedOption.value);

    setCustomerData(fullCustomer || null);
    setSelectedCustomer(selectedOption);
    fetchSubCustomersTec(selectedOption?.value);

    fetchCustomersProduct(selectedOption?.value);
  };

  const handleSubCustomerChange = (selectedOption) => {
    setSelectedSubCustomer(selectedOption);
  };

  useEffect(() => {
    if (cusAmcs[selectedBrandName?.value]?.length > 0) {
      setSelectedButton("AMC");
      setShowRateInput(false);
    } else {
      setShowRateInput(true);
    }
  }, [cusAmcs, selectedBrandName]);

  const handleCusAmcChange = (value) => {
    setSelectedCusAmc(value);

    if (value) {
      setSelectedButton("AMC");
      setShowRateInput(false);
    }
  };

  const handleBrandNameChange = (selectedOption) => {
    setSelectedBrandName(selectedOption);
    fetchCusAmc(selectedOption?.value);
  };

  const fetchFsrs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/fsrs/?page_size=all`, {
        headers: HEADERS,
      });
      setFsrData(response.data.results);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleButtonClicks = (button) => {
    if (button === "AMC") {
      setSelectedButton("AMC");
      setShowRateInput(false);
    } else if (button === "Rate") {
      setSelectedButton("Rate");
      setShowRateInput(true);
    }
  };

  const handleFormSubmit = async (data) => {
    const payload = {
      taskName: data.taskName,
      date: data.date,
      time: data.time,
      assignTo: selectedAssignTo?.value,
      israte: selectedButton === "Rate" ? "true" : "false",
      isamc: selectedButton === "AMC" ? "true" : "false",
      rate: selectedButton === "Rate" ? data.rate : null,
      address: data.address,
      landmark: data.landmark,

      model: data.model,
      purpose: data.purpose,
      customerDetails: selectedCustomer?.value || null,
      fsrDetails: selectedFsr?.value || null,
      serviceDetails: selectedService?.value || null,
      instructions: data.instructions,
      subCustomerDetails: selectedSubCustomer?.value || null,
      selected_cat: selectedCat?.value || null,

      selected_amc: selectedCusAmc?.value || null,
      product_name: selectedBrandName?.value,
    };

    let apiUrl;
    let apiMethod;

    if (action === "edit" && ticket?.id) {
      apiUrl = `${BASE_URL}/api/tickets/${ticket.id}/`;
      apiMethod = axios.put;
    } else {
      apiUrl = `${BASE_URL}/api/tickets/`;
      apiMethod = axios.post;
    }

    try {
      setLoading(true);
      const response = await apiMethod(apiUrl, payload, { headers: HEADERS });
      if (response) {
        handleClose();

        toast.success(
          `${
            action === "edit"
              ? "Ticket updated"
              : action === "reassign"
                ? "Ticket reassigned"
                : "Ticket created"
          } successfully.`,
        );

        if (location.pathname !== "/dashboard/tickets") {
          navigate("/dashboard/tickets");
        } else {
          fetchTickets();
        }
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAddCustomer = () => {
    setShowCreateCustomerModal(true);
  };

  const handleAddTech = () => {
    setShowTechnicianModal(true);
  };

  const handleAddSub = () => {
    setShowAddTagModal(true);
  };

  const fsrOptions = fsrData?.map((fsr) => ({
    value: fsr.id,
    label: fsr.fsrName,
  }));
  const serviceOptions = serviceData?.map((service) => ({
    value: service.id,
    label: service.service_name,
  }));

  const assignOptions = technicians
    ?.filter((tech) => tech.is_active === true)
    .map((tech) => ({
      value: tech.id,
      label: tech.first_name + " " + tech.last_name,
    }));

  const customerOptions = customers
    ?.filter((customer) => customer.is_active === true)
    .map((customer) => ({
      value: customer.id,
      label: `${customer.customer_name} ${
        customer.customer_tag ? `- ${customer.customer_tag}` : ""
      }`,
    }));

  const subcustomerOptions = subCustomers[selectedCustomer?.value]
    ?.filter((subCustomer) => subCustomer.is_active === true)
    .map((subCustomer) => ({
      value: subCustomer.id,
      label: subCustomer.customer_name || "None",
    }));

  const handleFsrChange = (selectedOption) => {
    setSelectedFsr(selectedOption);
    fetchFsrCat(selectedOption?.value);
  };

  const handleServiceChange = (selectedOption) => {
    setSelectedService(selectedOption);
  };

  const handleAssignChange = (selectedOption) => {
    setSelectedAssignTo(selectedOption);
  };

  const handleCloseWithReset = () => {
    setTicketAction(null);
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleCloseWithReset} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="taskName" className="form-label">
                  Task Name*
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="taskName"
                  placeholder="Enter task name"
                  {...register("taskName", { required: true })}
                />
                {errors.taskName && (
                  <span className="text-danger">Task Name is required</span>
                )}
              </div>

              <div className="col-md-3 mb-3">
                <label htmlFor="date" className="form-label">
                  Date*
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="date"
                  {...register("date", { required: true })}
                />
                {errors.date && (
                  <span className="text-danger">Date is required</span>
                )}
              </div>

              <div className="col-md-3 mb-3">
                <label htmlFor="time" className="form-label">
                  Time*
                </label>
                <input
                  type="time"
                  className="form-control"
                  id="time"
                  {...register("time", { required: true })}
                />
                {errors.time && (
                  <span className="text-danger">Time is required</span>
                )}
              </div>
            </div>

            <div className="row ">
              <div className="col-md-3 mb-3">
                <label htmlFor="assignTo" className="visually-hidden">
                  Assign To*
                </label>
                <Select
                  options={assignOptions}
                  value={selectedAssignTo}
                  onChange={handleAssignChange}
                  placeholder="Assign To*"
                  required
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "flex-start",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 100,
                      // maxHeight: "200px",
                      // overflowY: "auto",
                      marginTop: "5px",
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      textAlign: "left",
                      padding: "10px 15px",
                    }),
                  }}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => (
                      <Button
                        variant="link"
                        onClick={handleAddTech}
                        className="position-absolute end-0 top-0 mt-0"
                      >
                        <FaPlus />
                      </Button>
                    ),
                  }}
                />
                {errors.assignTo && (
                  <span className="text-danger">Assignee is required</span>
                )}
              </div>
              {!hiddenFields.includes("amc") && (
                <div className="col-md-3">
                  <button
                    className={`btn btn-outline-secondary mb-3 ${
                      selectedButton === "AMC" ? "bg-primary text-white" : ""
                    }`}
                    type="button"
                    onClick={() => handleButtonClicks("AMC")}
                    style={{ width: "100%", marginTop: "0px" }}
                    disabled={cusAmcs[selectedBrandName?.value]?.length === 0}
                  >
                    AMC
                  </button>
                </div>
              )}
              <div className="col-md-3">
                <button
                  className={`btn btn-outline-secondary mb-3 ${
                    selectedButton === "Rate" ? "bg-primary text-white" : ""
                  }`}
                  type="button"
                  onClick={() => handleButtonClicks("Rate")}
                  style={{ width: "100%", marginTop: "0px" }}
                  disabled={cusAmcs[selectedBrandName?.value]?.length > 0}
                >
                  Rate
                </button>
              </div>

              {showRateInput && selectedButton === "Rate" && (
                <div className="col-md-3">
                  <label htmlFor="rate" className="visually-hidden mb-3">
                    Rate*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="rate"
                    placeholder="Rate*"
                    {...register("rate", { required: true })}
                  />
                  {errors.rate && (
                    <span className="text-danger">Rate is required</span>
                  )}
                </div>
              )}
            </div>

            <div className="row ">
              <div className="col-md-12 mb-3">
                <textarea
                  className="form-control"
                  id="purpose"
                  placeholder="Purpose*"
                  rows="3"
                  {...register("purpose", { required: true })}
                />
                {errors.purpose && (
                  <span className="text-danger">Purpose is required</span>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <Select
                    id="customer"
                    name="customer"
                    placeholder={labels.customerName}
                    required
                    options={customerOptions}
                    value={selectedCustomer}
                    onChange={handleCustomerChange}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "40px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        justifyContent: "flex-start",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 100,

                        marginTop: "5px",
                      }),
                      option: (base, { isFocused }) => ({
                        ...base,
                        textAlign: "left",
                        padding: "10px 15px",
                      }),
                    }}
                    components={{
                      IndicatorSeparator: () => null,
                      DropdownIndicator: () => (
                        <Button
                          variant="link"
                          onClick={handleAddCustomer}
                          className="position-absolute end-0 top-0 mt-0"
                        >
                          <FaPlus />
                        </Button>
                      ),
                    }}
                  />
                  {errors.customer && (
                    <p className="text-danger">{errors.customer.message}</p>
                  )}
                </div>
              </div>

              {subCustomers[selectedCustomer?.value]?.length > 0 && (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <Select
                      id="subCustomer"
                      name="subCustomer"
                      placeholder={labels.subCustomerName}
                      options={subcustomerOptions}
                      value={selectedSubCustomer}
                      onChange={handleSubCustomerChange}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          justifyContent: "flex-start",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 100,
                          // maxHeight: "200px",
                          // overflowY: "auto",
                          marginTop: "5px",
                        }),
                        option: (base, { isFocused }) => ({
                          ...base,
                          textAlign: "left",
                          padding: "10px 15px",
                        }),
                      }}
                      isClearable
                      components={{
                        IndicatorSeparator: () => null,
                        DropdownIndicator: () => (
                          <Button
                            variant="link"
                            onClick={handleAddSub}
                            className="position-absolute end-0 top-0 mt-0"
                          >
                            <FaPlus />
                          </Button>
                        ),
                      }}
                    />
                    {errors.subCustomer && (
                      <span className="text-danger">Name is required</span>
                    )}
                  </div>
                </div>
              )}

              {brandNames[selectedCustomer?.value]?.length > 0 &&
                !hiddenFields.includes("product_name") && (
                  <div className="col-md-4 mb-3">
                    <div className="form-group">
                      <Select
                        id="product_name"
                        name="product_name"
                        placeholder="Product Name"
                        options={(
                          brandNames[selectedCustomer?.value] || []
                        ).map((brandName) => ({
                          value: brandName.id,
                          label: brandName.name || "None",
                        }))}
                        value={selectedBrandName}
                        onChange={handleBrandNameChange}
                        isClearable
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "40px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            justifyContent: "flex-start",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 100,
                            marginTop: "5px",
                          }),
                          option: (base, { isFocused }) => ({
                            ...base,
                            textAlign: "left",
                            padding: "10px 15px",
                          }),
                        }}
                      />

                      {errors.product_name && (
                        <span className="text-danger">
                          Product Name is required
                        </span>
                      )}
                    </div>
                  </div>
                )}

              {cusAmcs[selectedBrandName?.value]?.length > 0 &&
                !hiddenFields.includes("amc") && (
                  <div className="col-md-4 mb-3">
                    <div className="form-group">
                      <Select
                        id="selected_amc"
                        name="selected_amc"
                        placeholder="AMC Name"
                        options={(cusAmcs[selectedBrandName?.value] || []).map(
                          (cusAmc) => ({
                            value: cusAmc.amcid,
                            label: cusAmc.amcName || "None",
                          }),
                        )}
                        value={selectedCusAmc}
                        onChange={(value) => handleCusAmcChange(value)}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "40px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            justifyContent: "flex-start",
                          }),
                          menu: (base) => ({
                            ...base,
                            marginTop: "5px",
                          }),
                          option: (base, { isFocused }) => ({
                            ...base,
                            textAlign: "left",
                            padding: "10px 15px",
                          }),
                        }}
                        isClearable
                      />

                      {errors.selected_amc && (
                        <span className="text-danger">AMC is required</span>
                      )}
                    </div>
                  </div>
                )}

              {!hiddenFields.includes("model") && (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="model"
                      placeholder="Model No"
                      {...register("model")}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="row ">
              <div className="col  mb-3">
                <label htmlFor="fsr" className="visually-hidden">
                  FSR *
                </label>
                <Select
                  options={fsrOptions}
                  value={selectedFsr}
                  onChange={handleFsrChange}
                  placeholder="FSR Name*"
                  required
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "flex-start",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 100,
                      // maxHeight: "200px",
                      // overflowY: "auto",
                      marginTop: "5px",
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      textAlign: "left",
                      padding: "10px 15px",
                    }),
                  }}
                />
                {errors.fsr && (
                  <span className="text-danger">FSR is required</span>
                )}
              </div>

              {catNames[selectedFsr?.value]?.length > 0 && (
                <div className="col mb-3">
                  <div className="form-group">
                    <Select
                      id="selected_cat"
                      name="selected_cat"
                      placeholder="Fsr Category"
                      options={catNames[selectedFsr?.value] || []}
                      value={selectedCat}
                      onChange={(option) => setSelectedCat(option)}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          justifyContent: "flex-start",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 100,
                          marginTop: "5px",
                        }),
                        option: (base, { isFocused }) => ({
                          ...base,
                          textAlign: "left",
                          padding: "10px 15px",
                        }),
                      }}
                      isClearable
                    />

                    {errors.selected_cat && (
                      <span className="text-danger">
                        FSR Category is required
                      </span>
                    )}
                  </div>
                </div>
              )}

              <div className="col mb-3">
                <label htmlFor="service" className="visually-hidden">
                  Service *
                </label>
                <Select
                  options={serviceOptions}
                  value={selectedService}
                  onChange={handleServiceChange}
                  placeholder="Select a Service"
                  required
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "flex-start",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 100,
                      marginTop: "5px",
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      textAlign: "left",
                      padding: "10px 15px",
                    }),
                  }}
                />
              </div>
            </div>

            <div className="row ">
              <div className="col-md-12 mb-3">
                <label htmlFor="instructions" className="visually-hidden">
                  Instructions
                </label>
                <textarea
                  className="form-control"
                  id="instructions"
                  placeholder="Instructions"
                  {...register("instructions")}
                />
              </div>
            </div>

            <div className="text-end">
              <Button
                variant="secondary"
                className="mx-2"
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="mx-2"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </>
                ) : action === "edit" ? (
                  "Submit"
                ) : action === "reassign" ? (
                  "Reassign Ticket"
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <CreateCustomerModal
        show={showCreateCustomerModal}
        handleClose={() => setShowCreateCustomerModal(false)}
        fetchCustomers={fetchCustomers}
      />

      <AddTagModal
        show={showAddTagModal}
        handleClose={() => setShowAddTagModal(false)}
        fetchCustomers={fetchCustomers}
        customers={customers}
        fetchSubCustomers={fetchSubCustomersTec}
        selectedCustomer={customerData}
      />

      <AgentModal
        show={showTechnicianModal}
        handleClose={() => setShowTechnicianModal(false)}
        fetchAgents={fetchTechnicians}
        roletype="technician"
      />
    </>
  );
}

export default GenerateTicketsModal;
